import { render, staticRenderFns } from "./WereChangesAlert.vue?vue&type=template&id=62aa246e"
import script from "./WereChangesAlert.vue?vue&type=script&lang=js"
export * from "./WereChangesAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports